import { state } from 'cerebral'
import * as sequences from './sequences'
import apiClient from '../../lib/util/api-client'
import { createProviders } from '../providers'
import { redirectUnauthorized, createCrudState } from '../factories'
import { showFeedbackFromError } from '../feedback/factories'
import schemaSettings from '../../../shared/schemas/survey-reponse-schema'
const { surveyResponseSchema: schema } = schemaSettings

const service = apiClient.service('survey-responses')

export default ({ name }) => ({
  state: {
    ...createCrudState({ entityType: 'surveyResponses', storePrefix: name }),
    survey: null,
  },
  sequences,
  providers: {
    ...createProviders({ name, service, schema }),
  },
  catch: [
    redirectUnauthorized(),
    [
      Error,
      showFeedbackFromError({ title: 'We encountered an error' }),
      ({ props: { error, errorPath = name }, store }) => {
        store.set(state`errors.${errorPath}`, error)
      },
    ],
  ],
})
